import { useEffect } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getInspectionCertificates } from '../../use-cases/getInspectionsCertificates'

export function useGetInspectionCertificates(shipmentUUID: string, enabled: boolean) {
  const { call, result, status, error } = useAsync(getInspectionCertificates)
  const abortController = useAbortController()

  useEffect(() => {
    if (enabled) {
      call({
        shipmentUUID,
        config: {
          signal: abortController.signal,
        },
      })
    }
  }, [abortController, call, enabled, shipmentUUID])

  function fetchInspectionCertificates(shipmentUUID: string) {
    return call({
      shipmentUUID,
      config: {
        signal: abortController.signal,
      },
    })
  }

  return {
    inspectionCertificates: result,
    status,
    error,
    fetchInspectionCertificates,
  }
}
